module.exports = __webpack_public_path__ + "static/media/sub-bg.f3dbfc97.svg";